import React from "react";

// Vertical football pitch with markings. Children are absolutely positioned by consumers.
export function Pitch({ children, className = "" }) {
  return (
    <div className={`pitch-surface w-full ${className}`} style={{ aspectRatio: "68 / 100" }}>
      <PitchMarkings />
      <div className="absolute inset-0">{children}</div>
    </div>
  );
}

function PitchMarkings() {
  const line = "rgba(255,255,255,0.22)";
  return (
    <svg viewBox="0 0 68 100" className="absolute inset-0 w-full h-full" preserveAspectRatio="none" aria-hidden="true">
      <g fill="none" stroke={line} strokeWidth="0.35">
        <rect x="2" y="2" width="64" height="96" />
        <line x1="2" y1="50" x2="66" y2="50" />
        <circle cx="34" cy="50" r="9" />
        <circle cx="34" cy="50" r="0.6" fill={line} stroke="none" />
        {/* top box (attacking) */}
        <rect x="20" y="2" width="28" height="14" />
        <rect x="27" y="2" width="14" height="5" />
        <circle cx="34" cy="16" r="0.6" fill={line} stroke="none" />
        <path d="M26 16 A9 9 0 0 0 42 16" />
        {/* bottom box (own goal) */}
        <rect x="20" y="84" width="28" height="14" />
        <rect x="27" y="93" width="14" height="5" />
        <circle cx="34" cy="84" r="0.6" fill={line} stroke="none" />
        <path d="M26 84 A9 9 0 0 1 42 84" />
      </g>
    </svg>
  );
}
